import { Link } from "react-router-dom";
import { Icon } from "components/atoms";
import { Base } from "components/template";

const prefix = "v-account-requested";

const AccountRequested = () => {
  return (
    <Base
      footer={<>
        <Link target="_blank" to="/terms">Términos de uso</Link>
        <Link target="_blank" to="/privacy">Aviso de privacidad</Link>
      </>}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-4/5 md:w-3/5 lg:w-3/5 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-5 text-center">
          <Icon icon="check" className="text-green-500 mx-auto text-6xl"/>
          <p className="text-3xl font-bold">Gracias por tu interés en Nubesk</p>
          <div>
            <p className="text-lg">Estamos evaluando tu solicitud</p>
            <p className="text-lg">Pronto recibirás noticias en tu correo</p>
          </div>
        </div>
      </div>
    </Base>
  );
};

export default AccountRequested;
